export default {
  ISSUE: 'ISSUE',
  EXPIRATION: 'EXPIRATION',
  OUTGOING: 'OUTGOING',
  INCOMING: 'INCOMING',
  RECALL: 'RECALL',
  LOCKING: 'LOCKING',
};
